import { render, staticRenderFns } from "./CarbonEmissionsIcon.vue?vue&type=template&id=fc2f01f8&scoped=true"
import script from "./CarbonEmissionsIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./CarbonEmissionsIcon.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CarbonEmissionsIcon.vue?vue&type=style&index=0&id=fc2f01f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2f01f8",
  null
  
)

export default component.exports